<div class="header-wrapper">
  <div class="menu-btn-wrapper">
    <p-button (click)="onMenuOpen()" [rounded]="true" [outlined]="true" styleClass="p-button-white">
      <i class="p-button-icon pi pi-bars md:mr-2"></i>
      <span class="p-button-label hidden md:inline">Menu</span>
    </p-button>
  </div>
  <div class="logo-wrapper">
    <a href="https://ligapadla.pl/">
      <img src="assets/images/LigaPadlaPl.png" alt="Liga Padla" />
    </a>
  </div>
  <div class="account-btn-wrapper">
    @if (user()) {
      <div class="my-profile-btn__wrapper">
        <p-button
          class="my-profile-btn"
          severity="secondary"
          [rounded]="true"
          [outlined]="true"
          (onClick)="menu.toggle($event)">
          @if (user()?.avatar?.url) {
            <p-avatar [image]="user()?.avatar?.url" size="large" shape="circle" />
          } @else {
            <p-avatar [label]="userInitials()" size="large" shape="circle" />
          }
          <span class="p-button-label hidden md:inline">Moje konto</span>
        </p-button>
      </div>
      <p-menu #menu [model]="menuItems" [popup]="true" />
    } @else {
      <p-button severity="secondary" [rounded]="true" [outlined]="true" routerLink="/login">
        <i class="p-button-icon pi pi-user md:mr-2"></i>
        <span class="p-button-label hidden md:inline">Zaloguj się</span>
      </p-button>
    }
  </div>
</div>
